export const Initial = {
    productCategory: 'PC',
    customer: 'CU',
    site: 'SI',
    equipment: 'EQ',
    preventiveMaintenance: 'PM',
    emergencyCall: 'EC',
    serviceCall: 'SC',
    survey: 'SU',

};



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/displayid/id-initial.ts